module.exports = __webpack_public_path__ + "img/1.97531fd1.jpg";